// @vendors
import { Form } from 'antd';
import { useContext, useEffect, useState } from "react";
import InputMask from 'react-input-mask';
import Context from '../../../context/appContext';

export default function TextMaskField({ info, key, form, current }) {

    const validate = info.validate ? info.validate : {};
    const { dataForm: { data, formResponses, hiddenFields, disabledFields }, setDataForm, checked } = useContext(Context);
    const [message, setMessage] = useState({ help: '', status: 'success' });

    useEffect(() => {
        getDefaultValue();
        if (formResponses.findIndex(x => x.key === info.key) === -1) {
            formResponses.push(info);
        }
    }, []);

    useEffect(() => {
        disabledFields[info.key] && getDefaultValue();
    }, [disabledFields[info.key]]);

    const onChange = (event) => {
        const regex = new RegExp('[_ ]', 'ig');
        let value = event.target.value.replace(regex, '');
        const pattern = validate && validate.pattern;
        if (value && value.length === validate.maxLength && (pattern ? RegExp(pattern).test(value) : true)) {
            info.value = value;
            const index = formResponses.findIndex(x => x.key === info.key);
            index != -1 ? formResponses[index].value = value : formResponses.push(info);
            setMessage({ help: '', status: 'success' });
        } else {
            setMessage({ help: validate.customMessage, status: 'error' });
            (value.length !== validate.maxLength) && info.key.includes('telefono') && setMessage({ help: 'El número debe tener 10 dígitos', status: 'error' });
        }
    }

    const keyItems = {
        telefonoCelularAsegurado: true
    }

    const getDefaultValue = () => {
        const chkData = formResponses.find((item) => item.key === "datosContratanteIgualAsegurado");
        const hasCheckLoadLastStepInfo = current.newItems.find(x => x && x.key === "datosContratanteIgualAsegurado");

        let value = '';
        if (info.customDefaultValue && (!hasCheckLoadLastStepInfo || (hasCheckLoadLastStepInfo && chkData && chkData.value))) {
            const item = formResponses.find((x) => x && x.key && x.key.includes(info.customDefaultValue));
            value = item?.value ? item.value : info?.value ? info.value : '';
            disabledFields[info.key] = value && keyItems && !keyItems[info.key];
            setDataForm({ data, formResponses, hiddenFields, disabledFields: disabledFields });
        } else if (info && info.value && info.value !== null && info.value !== '') {
            value = info.value;
        }

        if (value && value !== '') {
            form.setFieldsValue({ [info.key]: value });
            onChange({ target: { value: value } });
        }
    }

    return (
        <Form.Item
            label={info.label}
            name={info.key}
            key={key}
            hidden={hiddenFields[info.key]}
            rules={[
                {
                    required: hiddenFields[info.key] || disabledFields[info.key] || info.disabled ? false : validate.required,
                    message: 'Este campo es requerido'
                },
                {
                    min: 6,
                    message: `El número debe tener  dígitos`
                },
                // {
                //     len :  10,
                //     message: `El número debe tener 10 dígitos`
                // },
                {
                    pattern: new RegExp(message.status === 'error' ? 'error' : ''),
                    message: message.help
                }
            ]}
        >
            <InputMask
                className='ant-input'
                mask={info.inputMask}
                placeholder={info.placeholder}
                disabled={disabledFields[info.key]}
                onChange={onChange}
            >

            </InputMask>

        </Form.Item>
    )
}